module.exports = __webpack_public_path__ + "/images/ico-social-color-linkedin.997e7db.svg";